module.exports = __webpack_public_path__ + "public/StoreIcon/vegetarian.svg?0e80c6e0";